import { useCallback } from 'react'
import _ from 'lodash'
import { submitStatusUpdates } from '../../../redux/submitStatusUpdates'
import L1ErrorBlock from '../l1/L1ErrorBlock'
import { useFormDispatch } from '../../../redux/formStoreHooks'
import { ConceptStatusValueType, ConceptValueDataType } from '@fusion-advantage/backcompat'
import { isConceptStatus } from '@fusion-advantage/formlib'
import { useConceptStatus, useConceptStatusValidity } from '../../../redux/selectConceptStatus2'
import { useConceptValidator } from './useConceptValidator'
import { useConceptActivation } from '../../../redux/selectConcept'
import L3DateSelect, { DateSelectPayload } from '../l3/L3DateSelect'

interface L4DateSelectProps {
	cid?: string,
	yearsToShow?: number,
	startYear?: number,
	endYear?: number,
	showDays?: boolean
}

const L4DateSelect = ({cid, yearsToShow, startYear, endYear, showDays}: L4DateSelectProps) => {
	const { concept, errorNode } = useConceptValidator({
		tagName: 'L4DateSelect',
		cid,
		requireConcept: true,
		allowDataTypes: [
			ConceptValueDataType.Date,
		],
	})

	const conceptStatus = useConceptStatus(cid)
	const validity = useConceptStatusValidity(cid)
	const activation = useConceptActivation(cid)
	const dispatch = useFormDispatch()

	const handleChange = useCallback((e: DateSelectPayload|null) => {
		dispatch(submitStatusUpdates([{
			cid: cid!,
			value: e?.date || null,
			valueType: ConceptStatusValueType.Chosen,
		}]))
	}, [dispatch, cid])

	if(errorNode) {
		return errorNode
	}
	if(conceptStatus && !isConceptStatus(conceptStatus)) {
		// probably passed SuperconceptStatus instead of ConceptStatus
		// which doesn't make sense for this control
		return <L1ErrorBlock content={`[L4DateSelect ${cid}] conceptStatus is incorrect type`} />
	}

	return (
		<L3DateSelect
			concept={concept!}
			conceptStatus={conceptStatus}
			validity={validity}
			activation={activation}
			onChange={handleChange}
			yearsToShow={yearsToShow}
			startYear={startYear}
			endYear={endYear}
			showDays={showDays}
		/>
	)
}

export default L4DateSelect
